export type COLUMN_TYPES = 'STATUS' | 'TEXT' | 'TIME' | 'GENDER'

export interface IColumnConfig     {
    matColumnDef: string;
    headerText: string;
    sortHeader: boolean;
    cellValue: any;
    type: COLUMN_TYPES;
    sticky?:boolean;
    stickyEnd?:boolean;
    showTooltip?:boolean;
}

const EMPLOYEE_DETAILS_COLUMN_CONFIG:IColumnConfig[] = [
    {
        matColumnDef: "status",
        headerText: "Status",
        sortHeader: true,
        cellValue: (element: any) => element.approvedBy,
        type: "STATUS",
        sticky:true,
        showTooltip:false
    },
    {
        matColumnDef: "employeeId",
        headerText: "Id",
        sortHeader: true,
        cellValue: (element: any) => element.approvedBy,
        type: "TEXT",
        sticky:true,
        showTooltip:false
    },
    {
        matColumnDef: "name",
        headerText: "Name",
        sortHeader: true,
        cellValue: (element: any) => element.approvedBy,
        type: "TEXT",
        showTooltip:false
    },
    {
        matColumnDef: "phoneNumber",
        headerText: "Phone",
        sortHeader: true,
        cellValue: (element: any) => element.approvedBy,
        type: "TEXT",
        showTooltip:false
    },
    {
        matColumnDef: "gender",
        headerText: "Gender",
        sortHeader: true,
        cellValue: (element: any) => element.approvedBy,
        type: "GENDER",
        showTooltip:false
    },
    {
        matColumnDef: "plannedPickupLocation",
        headerText: "Pickup Location",
        sortHeader: true,
        cellValue: (element: any) => element.approvedBy,
        type: "TEXT",
        showTooltip:true
    },
    {
        matColumnDef: "driverReportingTime",
        headerText: "Driver Reporting Time",
        sortHeader: true,
        cellValue: (element: any) => element.approvedBy,
        type: "TIME",
        showTooltip:false
    },
    {
        matColumnDef: "plannedPickupTime",
        headerText: "Planned Sign In/Sign Out",
        sortHeader: true,
        cellValue: (element: any) => element.approvedBy,
        type: "TIME",
        showTooltip:false
    },
    {
        matColumnDef: "actualPickupTime",
        headerText: "Actual Sign In/Sign Out",
        sortHeader: true,
        cellValue: (element: any) => element.approvedBy,
        type: "TIME",
        stickyEnd:true,
        showTooltip:false
    },
    {
        matColumnDef: "distanceTravelled",
        headerText: "Distance",
        sortHeader: true,
        cellValue: (element: any) => element.approvedBy,
        type: "TEXT",
        stickyEnd:true,
        showTooltip:false
    },
]
const UNKNOWN_RFID_COLUMNS:IColumnConfig[] = [
    {
        matColumnDef: "type",
        headerText: "Type",
        sortHeader: true,
        cellValue: (element: any) => element.approvedBy,
        type: "STATUS",
        showTooltip:false,
        sticky:true,
    },
    {
        matColumnDef: "name",
        headerText: "Employee Name",
        sortHeader: true,
        cellValue: (element: any) => element.approvedBy,
        type: "TEXT",
        showTooltip:false,
        sticky:true,
    },
    {
        matColumnDef: "gender",
        headerText: "Gender",
        sortHeader: true,
        cellValue: (element: any) => element.approvedBy,
        type: "GENDER",
        showTooltip:false
    },
    {
        matColumnDef: "stwid",
        headerText: "Employee ID",
        sortHeader: true,
        cellValue: (element: any) => element.approvedBy,
        type: "TEXT",
        sticky:true,
        showTooltip:false
    },
    {
        matColumnDef: "signinTimeStamp",
        headerText: "Event Time",
        sortHeader: true,
        cellValue: (element: any) => element.approvedBy,
        type: "TIME",
        sticky:true,
        showTooltip:false
    },
    // {
    //     matColumnDef: "signoutTimeStamp",
    //     headerText: "Event SignOut Time",
    //     sortHeader: true,
    //     cellValue: (element: any) => element.approvedBy,
    //     type: "TEXT",
    //     showTooltip:false
    // },
    {
        matColumnDef: "source",
        headerText: "Source",
        sortHeader: true,
        cellValue: (element: any) => element.approvedBy,
        type: "TEXT",
        sticky:true,
        showTooltip:false
    },
    {
        matColumnDef: "tag",
        headerText: "RFID Tag",
        sortHeader: true,
        cellValue: (element: any) => element.approvedBy,
        type: "TEXT",
        showTooltip:false,
        stickyEnd:true,
    },
    // {
    //     matColumnDef: "boardedStop",
    //     headerText: "Boarded Stop",
    //     sortHeader: true,
    //     cellValue: (element: any) => element.approvedBy,
    //     type: "TEXT",
    //     showTooltip:false
    // },

]


export const TABLE_COLUMNS = {
    EMPLOYEE_DETAILS_COLUMNS : EMPLOYEE_DETAILS_COLUMN_CONFIG,
    UNKNOWN_RFID_COLUMNS:UNKNOWN_RFID_COLUMNS
}